export const TimeTwentyFour = ({ size = "16" }: { size?: string }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_249_21392)">
      <path
        d="M11.8335 12.9316C11.8335 12.4012 11.6228 11.8925 11.2477 11.5174C10.8726 11.1424 10.3639 10.9316 9.8335 10.9316C9.30306 10.9316 8.79436 11.1424 8.41928 11.5174C8.04421 11.8925 7.8335 12.4012 7.8335 12.9316H9.16683C9.16683 12.7548 9.23707 12.5853 9.36209 12.4602C9.48712 12.3352 9.65669 12.265 9.8335 12.265C10.0103 12.265 10.1799 12.3352 10.3049 12.4602C10.4299 12.5853 10.5002 12.7548 10.5002 12.9316C10.5002 13.265 9.9335 13.6903 9.4335 14.065C8.6835 14.6276 7.8335 15.265 7.8335 16.265V16.9316H11.8335V15.5983H9.64016C9.82083 15.441 10.0328 15.2823 10.2335 15.1316C10.9835 14.569 11.8335 13.9316 11.8335 12.9316Z"
        fill="#706A85"
      />
      <path
        d="M15.1667 13.5983H13.8333V10.9316H12.5V13.5983C12.5 13.9519 12.6405 14.2911 12.8905 14.5411C13.1406 14.7912 13.4797 14.9316 13.8333 14.9316H15.1667V16.9316H16.5V10.9316H15.1667V13.5983Z"
        fill="#706A85"
      />
      <path
        d="M9.1665 4.93164H7.83317V8.26497H5.1665V9.59831H9.1665V4.93164Z"
        fill="#706A85"
      />
      <path
        d="M15.1666 2.26455V4.51388C14.4508 3.43136 13.4823 2.5393 12.3447 1.91473C11.2071 1.29015 9.9346 0.951834 8.63704 0.928975C7.33947 0.906116 6.05583 1.1994 4.89695 1.78352C3.73806 2.36764 2.73875 3.22503 1.98529 4.28167C1.23182 5.33832 0.746849 6.56246 0.572231 7.84843C0.397613 9.1344 0.5386 10.4435 0.983019 11.6628C1.42744 12.8822 2.16194 13.975 3.1231 14.847C4.08427 15.719 5.24322 16.3439 6.4999 16.6679V15.2906C5.46343 14.9682 4.52137 14.3976 3.75554 13.6283C2.98971 12.8591 2.42329 11.9146 2.10548 10.8767C1.78767 9.8388 1.72809 8.73902 1.93191 7.67288C2.13573 6.60675 2.59679 5.6065 3.27503 4.75905C3.95327 3.91159 4.82818 3.24257 5.82375 2.81009C6.81932 2.37761 7.90543 2.19476 8.98772 2.27742C10.07 2.36009 11.1157 2.70577 12.0341 3.28444C12.9524 3.86311 13.7156 4.65725 14.2572 5.59788H11.8332V6.93122H15.1666C15.5202 6.93122 15.8593 6.79074 16.1094 6.54069C16.3594 6.29065 16.4999 5.95151 16.4999 5.59788V2.26455H15.1666Z"
        fill="#706A85"
      />
    </g>
    <defs>
      <clipPath id="clip0_249_21392">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(0.5 0.931641)"
        />
      </clipPath>
    </defs>
  </svg>
);
